import {initializeApp} from 'firebase/app';
import { getAuth } from "firebase/auth";


const firebaseConfig = {
    apiKey: "AIzaSyDZYEu1sGQH85nvxY6cX3HZXtooCPVnZGM",
    authDomain: "vitafirebase.firebaseapp.com",
    projectId: "vitafirebase",
    storageBucket: "vitafirebase.firebasestorage.app",
    messagingSenderId: "302790807937",
    appId: "1:302790807937:web:bdf7c9f4d31f9e38db5880",
    measurementId: "G-Y6L6T7VXHX"

}


const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export default app;